<template>
  <div id="editor" class="markdown-editor">
    <v-row>
      <v-col v-if="!disabled" cols="6">
        <v-textarea
          :value="input"
          @input="update"
          :disabled="disabled"
          label="Markdown input"
          rows="15"
          outlined
        />
      </v-col>
      <v-col :cols="disabled ? 12 : 6">
        <div class="preview" v-html="compiledMarkdown"></div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import _ from 'lodash';

export default {
  name: 'MarkdownEditor',
  props: {
    inputText: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      input: '',
    };
  },
  created() {
    if (this.inputText != null) this.input = this.inputText;
  },
  watch: {
    inputText(newVal) {
      // keep editor in sync if parent value changes
      this.input = newVal ?? '';
    },
  },
  computed: {
    compiledMarkdown() {
      return DOMPurify.sanitize(marked(this.input || ''));
    },
  },
  methods: {
    update: _.debounce(function (val) {
      this.input = val;
      this.$emit('onMediaData', this.input);
    }, 300),
  },
};
</script>

<style scoped>
.markdown-editor {
  padding: 16px;
}

.preview {
  border: 1px solid #ccc;
  background-color: #f9f9f9;
  padding: 16px;
  min-height: 430px;
  max-height: 430px;
  overflow-y: auto;
}
</style>
